export const GET_GENERAL_BANK_INFOS = "GET_GENERAL_BANK_INFOS"
export const GET_GENERAL_BANK_INFOS_ERR = "GET_GENERAL_BANK_INFOS_ERR"

export const RESET_GENERAL_BANK_INFOS = "RESET_GENERAL_BANK_INFOS"